import en from "./en";
import fr from "./fr";
import nl from "./nl";

export const messages = {
  en,
  fr,
  nl
};

export default function(id) {
  let lng = "fr";
  if (typeof window !== "undefined") {
    try {
      lng = localStorage.getItem("lng");
    } catch (e) {}
  }

  if(lng == null) {
    lng = 'fr';
  }

  return messages[lng][id] && 0 !== messages[lng][id].length
    ? messages[lng][id]
    : id;
}



// WEBPACK FOOTER //
// ./app/i18n/index.js